import DTILogo from '../icons/DTILogo';
import DTILogoHover from '../icons/DTILogoHover';
import RevProLogo from '../icons/RevProLogo';
import RevProLogoHover from '../icons/RevProLogoHover';
import VictoryLiveLogo from '../icons/VictoryLiveLogo';
import VictoryLiveLogoHover from '../icons/VictoryLiveLogoHover';
import TKTEdgeLogo from '../icons/TKTEdgeLogo';
import TKTEdgeLogoHover from '../icons/TKTEdgeLogoHover';
import BNLogo from '../icons/BNLogo';
import BNLogoHover from '../icons/BNLogoHover';

interface LogoProps {
  size?: number;
  brand?: 'dti' | 'revpro' | 'victorylive' | 'tktedge' | 'bn';
  variant?: 'hover' | 'default';
}

export default function Logo({ size = 48, brand = 'bn', variant = 'default' }: LogoProps) {
  if (brand === 'dti') {
    return variant === 'hover' ? <DTILogoHover size={size} /> : <DTILogo size={size} />;
  }
  if (brand === 'revpro') {
    return variant === 'hover' ? <RevProLogoHover size={size} /> : <RevProLogo size={size} />;
  }
  if (brand === 'victorylive') {
    return variant === 'hover' ? <VictoryLiveLogoHover size={size} /> : <VictoryLiveLogo size={size} />;
  }
  if (brand === 'tktedge') {
    return variant === 'hover' ? <TKTEdgeLogoHover size={size} /> : <TKTEdgeLogo size={size} />;
  }
  return variant === 'hover' ? <BNLogoHover size={size} /> : <BNLogo size={size} />;
}
